<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ 'planRestriction.title' | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="close()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <div class="limit-plan-dialog__info">
      <p *ngIf="restrictionType === 'analytics'">{{ 'planRestriction.analytics' | translate }}</p>
      <p *ngIf="restrictionType === 'template'">{{ 'planRestriction.template' | translate }}</p>
      <p *ngIf="restrictionType === 'admin'">{{ 'planRestriction.admin' | translate }}</p>
      <p *ngIf="restrictionType === 'api'">{{ 'planRestriction.api' | translate }}</p>
      <p *ngIf="restrictionType === 'banner'">{{ 'planRestriction.banner' | translate }}</p>
      <p *ngIf="restrictionType === 'link'">{{ 'planRestriction.link' | translate }}</p>
      <p *ngIf="restrictionType === 'disclaimer'">{{ 'planRestriction.disclaimer' | translate }}</p>
      <p *ngIf="restrictionType === 'subdomain'">{{ 'planRestriction.subdomain' | translate }}</p>
      <p *ngIf="restrictionType === 'customVariable'">{{ 'planRestriction.customVariable' | translate }}</p>
      <p *ngIf="restrictionType === 'domainRules'">{{ 'planRestriction.domainRules' | translate }}</p>
      <p *ngIf="restrictionType === 'internalSignature'">{{ 'planRestriction.internalSignature' | translate }}</p>
      <p *ngIf="restrictionType === 'mediaStorage'">{{ 'planRestriction.mediaStorage' | translate }}</p>
      <p *ngIf="restrictionType === 'general'">{{ 'planRestriction.general' | translate }}</p>
    </div>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="close()">{{ 'close' | translate }}</button>
    <button mat-raised-button color="primary" type="button" (click)="goToSubscription()">
      <mat-icon>payment</mat-icon>
      {{ 'planRestriction.goToSubscription' | translate }}
    </button>
  </footer>
</div>
